export default {
    init() {
      // JavaScript to be fired on a single person
      $('.woocommerce-product-gallery__image a').on('click', function(e) {
          e.preventDefault();
      });
    },
  };


// WEBPACK FOOTER //
// ./scripts/routes/single-product.js